/** DRF list endpoints return either a bare array or a paginated envelope. */
export type Collection<T> =
  | T[]
  | {
      count?: number;
      next?: string | null;
      previous?: string | null;
      results?: T[];
    };

export function extractCollection<T>(payload: Collection<T>): T[] {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.results)) return payload.results;
  return [];
}
